import * as t from '~/messages'
import { useOAuthPopup } from '~/composables/oauth-popup'
import type { GoogleLoginRequest } from '~/types/on24-klient'

export const usePerformGoogleLogin = () => {
  if (!import.meta.client) {
    return () => {}
  }

  const errorStore = useLoginErrorStore()
  const loginReturnTo = useLoginReturnTo()

  return async (token: string) => {
    try {
      await $fetch<undefined>('/api/login/google', {
        method: 'POST',
        body: {
          credential: token,
        } satisfies GoogleLoginRequest,
      })
      await loginReturnTo.redirectFromLogin()
      return
    } catch {
      errorStore.setLoginErrorMessage(t['w.login.google.error.generic_login']())
      await loginReturnTo.navigateToLogin()
    }
  }
}

export const useGoogleLogin = () => {
  if (!import.meta.client) {
    return { login() {} }
  }

  const loginCallback = usePerformGoogleLogin()
  const errorStore = useLoginErrorStore()
  const loginReturnTo = useLoginReturnTo()

  const popup = useOAuthPopup()

  const login = () =>
    popup.open('/auth/google', loginCallback, async () => {
      errorStore.setLoginErrorMessage(t['w.login.google.error.generic_login']())
      await loginReturnTo.navigateToLogin()
    })

  return { login }
}
